<script lang="js" setup>
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/24/solid'
import FAQ from './faqData.js'
</script>

<template>
  <div class="w-full">
    <div class="max-w-screen-md flex flex-col gap-y-4">
      <Disclosure v-for="(item, index) in FAQ" :key="index" v-slot="{ open }">
        <div>
          <DisclosureButton
            class="flex w-full gap-x-4 justify-between items-center rounded-lg bg-gray-50 p-4 lg:p-7 font-poppins text-left text-sm sm:text-lg lg:text-xl font-medium text-[#292929] focus:outline-none focus-visible:ring focus-visible:ring-primary"
          >
            <span>{{ item.question }}</span>
            <ChevronDownIcon
              :class="open ? 'rotate-180 transform' : ''"
              class="h-5 w-5 text-black"
            />
          </DisclosureButton>
          <transition
            enter-active-class="transition duration-300 ease-out"
            enter-from-class="transform scale-y-0 opacity-0"
            enter-to-class="transform scale-y-100 opacity-100"
            leave-active-class="transition duration-200 ease-in"
            leave-from-class="transform scale-y-100 opacity-100"
            leave-to-class="transform scale-y-0 opacity-0"
          >
            <DisclosurePanel
              class="px-4 pb-4 text-sm text-gray-500 bg-gray-50 origin-top"
            >
              {{ item.answer }}
            </DisclosurePanel>
          </transition>
        </div>
      </Disclosure>
    </div>
  </div>
</template>
<style scoped></style>
